import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { cn } from '../../../utils/cn';
import { SimpleTooltip } from './SimpleTooltip';

interface RefreshTimerProps {
  lastRefreshTime: number;
  autoRefreshInterval?: number; // Default 60000ms
  className?: string;
}

export const RefreshTimer: React.FC<RefreshTimerProps> = ({
  lastRefreshTime,
  autoRefreshInterval = 60000,
  className,
}) => {
  const [secondsRemaining, setSecondsRemaining] = useState<number>(60);

  useEffect(() => {
    const updateCountdown = () => {
      const elapsed = Date.now() - lastRefreshTime;
      const remaining = Math.max(0, Math.ceil((autoRefreshInterval - elapsed) / 1000));
      setSecondsRemaining(remaining);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [lastRefreshTime, autoRefreshInterval]);

  return (
    <SimpleTooltip content="Atualização automática a cada 60 segundos. Pressione F5 para atualizar manualmente.">
      <div className={cn("flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-gray-800/50 border border-gray-700 cursor-help", className)}>
        <Clock className="h-3.5 w-3.5 text-blue-400" />
        <span className="text-xs font-medium text-gray-300">
          Atualiza em {secondsRemaining}s
        </span>
      </div>
    </SimpleTooltip>
  );
};
